<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-crypto__chain">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.chainName" placeholder="请输入区块链名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('crypto:chain:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('crypto:chain:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="chainCode" label="区块链代码" header-align="center" align="center" width="150"></el-table-column>
        <el-table-column prop="chainName" label="区块链名称" header-align="center" align="center" width="150"></el-table-column>
        <el-table-column prop="chainNameEn" label="英文名称" header-align="center" align="center" width="150"></el-table-column>
        <el-table-column prop="explorerUrl" label="浏览器URL" :show-overflow-tooltip="true" header-align="center" align="center"></el-table-column>
        <el-table-column prop="rpcUrl" label="API地址" :show-overflow-tooltip="true" header-align="center" align="center"></el-table-column>
        <el-table-column prop="ext1" label="TRON-PRO-API-KEY" :show-overflow-tooltip="true" header-align="center" align="center"></el-table-column>
        <el-table-column prop="addressPattern" label="地址正则" :show-overflow-tooltip="true" header-align="center" align="center"></el-table-column>
        <el-table-column prop="isEnabled" label="启用状态" header-align="center" align="center" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isEnabled === 1" type="success">启用</el-tag>
            <el-tag v-else-if="scope.row.isEnabled === 2" type="danger">禁用</el-tag>
            <el-tag v-else-if="scope.row.isEnabled === 0" type="info">未知</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="sortOrder" label="排序" header-align="center" align="center" width="80"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('crypto:chain:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('crypto:chain:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="refreshDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './chain-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/crypto/chain/list',
        getDataListIsPage: true,
        deleteURL: '/crypto/chain',
        deleteIsBatch: true
      },
      dataForm: {
        chainName: ''
      }
    }
  },
  components: {
    AddOrUpdate
  }
}
</script>
